/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetPostByIdState, PostagemPaged, PostByIdRequest } from "store/modules/posts/types";

const initialState: GetPostByIdState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const getPostByIdSlice = createSlice({
    name: "posts@getPostById",
    initialState,
    reducers: {
        getPostByIdRequest: (
            state,
            action: PayloadAction<PostByIdRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getPostByIdSuccess: (
            state,
            action: PayloadAction<PostagemPaged & { photoAsFile?: File } | null>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getPostByIdFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.successPayload = null;
            state.isRequesting = false;
            state.errors = action.payload;
        },
        cleanPostData: (state, action: PayloadAction) => {
            state.successPayload = null;
        }
    }
});

export const {
    getPostByIdFailed,
    getPostByIdRequest,
    getPostByIdSuccess,
    cleanPostData
} = getPostByIdSlice.actions;
export default getPostByIdSlice.reducer;
